import { arrayHelpers } from "@tweddle-se-team/common/helpers";
import { uniq } from "ramda";
import pubhub from "@/utils/apiHelpers/pubhubData";
import { productActions } from "@/store/products";

const { byEnglishFirst } = arrayHelpers;

export const getProductsForStore = async (lng) => {
  const query = {};

  if (lng === "uk") {
    query.langFilter = lng;
  }

  const [all, locales, metadata] = await Promise.all([
    pubhub.getProducts(query),
    pubhub.getLocales(),
    pubhub.getMetadataTags(),
  ]);
  const language = uniq(locales.map((l) => l.replace(/_.*/, ""))).sort(
    byEnglishFirst
  );
  return { all, optionsPerFilter: { language, metadata } };
};

const getProducts = async (store, language) => {
  const { getState, dispatch } = store;
  let { products } = getState();
  if (!products.all?.length) {
    dispatch(productActions.SET(await getProductsForStore(language)));
    products = getState().products;
  }
  return products;
};

const productHelpers = {
  getProducts,
};

export default productHelpers;
